import { clientbookApi } from '../core/clientbook-api';

/**
 * Get attribution data for a set of mass messages
 * @param {Object} options
 * @param {number[]} options.massMessageIds - Array of mass message IDs
 */
export const getMassMessageAttribution = async ({ massMessageIds }) => {
  return clientbookApi.post({
    url: '/reports/mass-messages/attribution',
    data: { massMessageIds },
    loading: false,
  });
};

/**
 * Get attribution summary (totals + per-message attribution)
 * @param {Object} options
 * @param {number[]} options.massMessageIds - Array of mass message IDs
 */
export const getMassMessageAttributionSummary = async ({ massMessageIds }) => {
  return clientbookApi.post({
    url: '/reports/mass-messages/attribution/summary',
    data: { massMessageIds },
    loading: false,
  });
};

/**
 * Get attributed sales for a mass message
 * @param {Object} options
 * @param {number} options.massMessageId
 */
export const getMassMessageAttributedSales = async ({ massMessageId }) => {
  return clientbookApi.get({
    url: `/reports/mass-messages/${massMessageId}/sales`,
    loading: false,
  });
};
